import styled from "@emotion/styled";
import { FC } from "react";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react"; 
// custom
import userLogo from '../../assets/img/user-logo.png';
import { removeLocalStorageItem } from "../../common/helpers/LocalStorage";

const NavbarImageStyled = styled.img`
  position: relative;
  top: -2px;
  width: 25px;
  height: auto;
  margin-left: 10px;
`;

const NavbarUser: FC = () => {
    const { logout } = useAuth0();
    // evt handlers
    function handleToggleDropdown() {
      const dom = document.getElementById("navbar-side-vertical-columns");
      if (dom && dom.classList.contains("hidden")) dom?.classList.remove("hidden");
      else dom?.classList.add("hidden");
    }

    // evt handlers
    // evt handlers
    function handleLogout() {
      logout({ logoutParams: { returnTo: window.location.origin } });
    }

    return <nav className="relative flex flex-wrap items-center justify-between px-2 py-3 shadow-md bg-secondary-700">
    <div className="container flex flex-wrap items-center justify-between px-4 mx-auto">
      <div className="relative flex justify-between w-full px-4 lg:w-auto lg:static lg:block lg:justify-start">
        <Link to="/profile" className="flex inline-block py-2 mr-4 text-sm font-bold leading-relaxed text-white uppercase whitespace-nowrap">          
          My Dashboard
          <NavbarImageStyled src={userLogo} title="Admin"/>
        </Link>        
        <button onClick={handleToggleDropdown}
          className="block px-3 py-1 text-xl leading-none bg-transparent border border-transparent border-solid rounded outline-none cursor-pointer lg:hidden focus:outline-none" type="button">
          <span className="relative block w-6 h-px bg-white rounded-sm"></span>
          <span className="relative block w-6 h-px mt-1 bg-white rounded-sm"></span>
          <span className="relative block w-6 h-px mt-1 bg-white rounded-sm"></span>
        </button>
      </div>
      <div className="items-center flex-grow hidden lg:flex" id="navbar-side-vertical-columns">
        <ul className="flex flex-col ml-auto list-none lg:flex-row">
            <li className="nav-item">
              <Link to="/profile/details" className="flex items-center px-3 py-2 text-xs font-bold leading-snug text-white uppercase hover:opacity-75">
                 My Profile
              </Link>
            </li>  
            <li className="nav-item">
              <Link to="/profile/events" className="flex items-center px-3 py-2 text-xs font-bold leading-snug text-white uppercase hover:opacity-75">
                 Register
              </Link>
            </li>            
            <li className="nav-item">
              <Link to="/profile/contact" className="flex items-center px-3 py-2 text-xs font-bold leading-snug text-white uppercase hover:opacity-75">
                Contact Us
              </Link>
            </li>
            <li className="nav-item">
              <a href="https://www.powerministry.info/#/index" target="_blank" rel="noopener noreferrer" className="flex items-center px-3 py-2 text-xs font-bold leading-snug text-white uppercase hover:opacity-75">
                Website
              </a>
            </li>
            <li className="nav-item">
              <button onClick={handleLogout}
                className="flex items-center px-3 py-2 text-xs font-bold leading-snug text-white uppercase hover:opacity-75">
                  Logout
              </button>
            </li>
        </ul>
      </div>
    </div>
  </nav>;
};

export default NavbarUser;